// extracted by mini-css-extract-plugin
module.exports = {"link":"RecoverPass_link__Z_eL_"};